import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import {
  ContentWidth,
  TextWidthExtended,
} from '@ta-interaktiv/react-disco-grid'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { useContext, useEffect, useRef, useState } from 'react'
import Survey from 'components/Survey'
import { firebaseContext } from './FirebaseContext'
import { child, update } from 'firebase/database'
import Evaluation from 'components/Evaluation'
import {
  ResetButton,
  readLocalStorage,
  writeToLocalStorage,
} from 'components/Utils/localstorage'
import { useWindowSize } from 'usehooks-ts'
import '../../Globals/font.css'
import { _t, setLanguage, setTranslations } from 'components/Utils/translation'
import { translations_sex_umfrage } from 'components/Utils/translation_strings'
import Header from 'components/Header'

const isDev = window.document.title === 'TA-Interaktiv Microfrontend'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const [userAnswers, setUserAnswers] = useState<Answers>()
  const scrollRef = useRef(null)
  const firebaseGlobals = useContext(firebaseContext)
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 712
  var part = properties?.part || '0'
  setTranslations(translations_sex_umfrage)
  setLanguage(tenant.lang)

  useEffect(() => {
    // read loud player disable
    document.getElementById('bt-player')?.style.setProperty('display', 'none')
  }, [])

  function setUserState(state: boolean, answers: Answers | undefined) {
    if (state && answers) {
      if (answers.send) {
        setUserAnswers(answers)
      } else {
        const answercopy = { ...answers }

        sendUserAnswersToFirebase(answercopy)

        answers.send = true
        setUserAnswers(answers)
        writeToLocalStorage(answers, true)
      }
    }
  }

  const sendUserAnswersToFirebase = (answers: Answers) => {
    if (!answers) return
    const fr_tenants = ['tdg', '24heures']
    answers.defr = fr_tenants.includes(tenant.key) ? 'fr' : 'de'
    update(
      child(firebaseGlobals.users, `${firebaseGlobals.uniqueId}/`),
      answers
    ).then((a) => {
      var answers = readLocalStorage()
      if (answers) {
        answers.send = true
        writeToLocalStorage(answers)
      }
    })
  }

  const Width =
    windowSize.width > 540 && windowSize.width < 712
      ? TextWidthExtended
      : ContentWidth

  return (
    <AppContainer $colorMode={colorMode}>
      {(part === '0' || isDev) && (
        <Width>
          <Center>
            <Header
              pubDate='Publiziert am XX. Juni 2024'
              tenant={tenant}
              colorMode={colorMode}
              title={'Wie oft haben Sie Sex und wie zufrieden sind Sie damit?'}
              oberzeile={'21 intime Fragen'}
              lead={
                'Sexuelles Vergnügen, Masturbation und Orgasmen: Vergleichen Sie Ihr Sexleben mit jenen der anderen Leserinnen und Lesern.'
              }
            />
          </Center>
        </Width>
      )}

      {(part === '1' || isDev) && (
        <>
          <div id='scrollTo' ref={scrollRef} />
          <ScrollTarget />
          <Width>
            <>
              {!userAnswers && (
                <>
                  {isDev && <ResetButton lang={tenant.lang}/>}
                  {isDev && (
                    <button
                      style={{ zIndex: '3000', position: 'relative' }}
                      onClick={() => {
                        setUserAnswers({
                          gender: 'female',
                          age: 'age_40_to_49',
                          sexual_orientation: 'other',
                          relationship_status: 'single',
                          //
                          education: 'compulsory',
                          relationship_duration: 0,
                          satisfaction: 3,
                          sex_frequency: 'three_to_four_times_month',
                          sex_frequency_desired: 'less',
                          orgasm_frequency_sex: 15,
                          orgasm_frequency_desired: 'less',
                          masturbation_frequency: 'two_to_three_times_week',
                          orgasm_frequency_masturbation: 30,
                          pleasure_frequency_masturbation: 30,
                          group_agree_like: 1,
                          pleasure_frequency_sex: 20,
                          group_agree_demand: 3,
                          group_agree_think: 3,
                          genital_look: 2,
                          genital_function: 1,
                          realize_sexual_demands: 2,
                          communicate_needed_mood: 1,
                          right_to_orgasm: 1,
                        })
                      }}
                    >
                      Fill
                    </button>
                  )}
                  <Survey
                    lang={tenant.lang}
                    setUserState={setUserState}
                    colorMode={colorMode}
                  />
                </>
              )}
            </>
          </Width>

          {userAnswers && (
            <ContentWidth>
              <Evaluation
                lang={tenant.lang}
                answers={userAnswers}
                colorMode={colorMode}
              />
            </ContentWidth>
          )}
        </>
      )}
    </AppContainer>
  )
}

const ScrollTarget = () => {
  const scrollRef = useRef(null)
  useEffect(() => {
    if (scrollRef.current) {
      ;(window as any).scrollTarget = scrollRef.current
      ;(window as any).scrollPos = (
        scrollRef.current as HTMLElement
      ).getBoundingClientRect().y
    }
  }, [scrollRef.current])
  return <div id='scrollTo' ref={scrollRef} />
}

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  /* margin-top: 100px; */
  /* overflow-x: hidden; */
  p {
    font-family: var(--font-serif);
    line-height: 30px;
  }

  svg * {
    user-select: none;
  }
`
export default MainComponent
